<section class="content">
    <!-- <div class="d-flex justify-content-between">
        <ul class="nav nav-tabs" id="myTab" role="tablist" style="width: calc(100% - 4rem)">        
            <li class="nav-item" *ngFor="let t of types">
                <a class="nav-link" [class.active]="tab==t.id" (click)="tab=t.id">
                    <i class="fas fa-archive mr-2"></i>{{t.name}}
                </a>
            </li>
        </ul>
        <i *ngIf="currentUser.isAdmin()" class="fas fa-user-cog pointer mr-2" title="Configura" (click)="openSettings()"></i>
    </div> -->
    <div class="tab-content" id="myTabContent">
        <div class="form-group form-group-sm mb-3 d-none d-lg-block" >
            <div class="input-group input-group-sm">
                <!-- <div class="input-group-prepend input-group-prepend-sm" *ngIf="currentUser.isAdmin()">
                    <button type="button" class="btn btn-sm btn-default" (click)="openSettings()">
                        <i class="fas fa-cog"></i>
                    </button>
                </div> -->
                <select class="form-control form-control-sm font-weight-bold" #tabSelect (change)="tab=tabSelect.value;">
                    <option value="0">Generalità</option>
                    <!-- <option value="-1">Tutti (dettaglio)</option> -->
                    <ng-container class="nav-item" *ngFor="let t of types">
                        <option value="{{t.id}}">{{t.name}} (dettaglio)</option>
                    </ng-container>
                </select>               
            </div>
        </div>
        
        <div class="tab-pane show active" *ngIf="tab==0">
            <app-dossierlistall (selectedRecordOut)="recordSelected=$event" [modalWindow]="modalWindow" [mode]="mode"></app-dossierlistall>
        </div>
        
        <!-- <div class="tab-pane show active" *ngIf="tab==-1">
            <app-dossierlist [mode]="mode" [id_type]="" (selectedRecordOut)="recordSelected=$event" [modalWindow]="modalWindow" [mode]="mode"></app-dossierlist>
        </div> -->

         <ng-container *ngFor="let t of types">            
            <div class="tab-pane show active" *ngIf="tab==t.id">
                <app-dossierlist [mode]="mode" [id_type]="t.id" (selectedRecordOut)="recordSelected=$event" [modalWindow]="modalWindow" [mode]="mode"></app-dossierlist>
            </div>
        </ng-container>
               
    </div>
</section>